// @flow weak
/*
Sniff actions and track.
*/

import _ from 'lodash';
import { ROUTE_TO } from 'redux-router-kit';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import TrackActions from './tracking/Actions';

export default ({ dispatch, getState }) => {
  const types = {
    [ROUTE_TO]: action => {
      void TrackActions.trackPageViewEvent();

      const isInitialPageLoad = !RouterSelectors.getCurrentPathname(getState());
      // We don't want to GA track the initial page load because
      // the GA script already does that by default for us.
      if (isInitialPageLoad) {
        return;
      }

      const path = _.get(action, ['meta', 'location', 'pathname']);
      dispatch(TrackActions.gaPageTrack(path));
    },
  };

  return next => action => {
    if (action && types[action.type]) {
      types[action.type](action);
    }

    return next(action);
  };
};
